import React from 'react'
import styled from 'styled-components'
import { ReactFC } from 'types'
import styles from './TabPanel.css'

export const TabPanel: ReactFC<{ value, index } & React.HTMLAttributes<HTMLDivElement>> = (props) => {
    const { children, value, index, ...other } = props

    return (
        <TabPanelWrapper className="tab_panel"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {(value === index && children) || null}
        </TabPanelWrapper>
    )
}
const TabPanelWrapper = styled.div`
    padding-left: 10px;
    width: 100%;
    & .custom_text {
        color: #8028D8;
    } 
  
`
